import { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { SAMPLING_FIELD_MAX, SAMPLING_FIELD_MIN } from "@features/run/RunGroupDialog/schema"
import { TextField } from "@mui/material"
import { getErrorMessage } from "@utils/form"
import { Controller, useFormContext } from "react-hook-form"

export const RunGroupFieldNumberOfSamplings = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<RunGroupFormValues>()

  return (
    <Controller
      name="number_of_samplings"
      control={control}
      render={({ field }) => (
        <TextField
          error={Boolean(errors[field.name])}
          helperText={getErrorMessage(errors, field.name)}
          label="Number of sampling iterations"
          variant="standard"
          inputProps={{
            min: SAMPLING_FIELD_MIN,
            max: SAMPLING_FIELD_MAX,
            step: 100,
            type: "number",
          }}
          {...field}
        />
      )}
    />
  )
}
